import { render, staticRenderFns } from "./CarbonFootprintSummary.vue?vue&type=template&id=1b5179a2"
import script from "./CarbonFootprintSummary.vue?vue&type=script&lang=js"
export * from "./CarbonFootprintSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports